export { default } from './SummaryTableCell';
